export enum ActionIcons {
  SCANNING = "35",
  CUSTOMS = "36",
  WEIGHING = "37",
}
